import {
  DEPARTMENT_GET_LIST,
  DEPARTMENT_GET_LIST_SUCCESS,
  DEPARTMENT_GET_LIST_ERROR,
  POSITION_GET_LIST,
  POSITION_GET_LIST_SUCCESS,
  POSITION_GET_LIST_ERROR,
} from '../actions';

const INIT_STATE = {
  loading: false,
  error: '',
  departments: [],
  positions: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEPARTMENT_GET_LIST:
      return { ...state, loading: true };
    case DEPARTMENT_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: action.payload,
        error: '',
      };
    case DEPARTMENT_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case POSITION_GET_LIST:
      return { ...state, loading: true };
    case POSITION_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        positions: action.payload,
        error: '',
      };
    case POSITION_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        item: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
};
